module.exports = __webpack_public_path__ + "static/media/patents.df0ed135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/patents.jpg
// module id = 1366
// module chunks = 0